import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const SendGiftReviewTemplate = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px auto;
  max-width: 1024px;
  width: 100%;

  ${DEVICE.tablet.max} {
    margin: 16px auto;
    max-width: 100%;
  }
`;

export { SendGiftReviewTemplate };
